import AutoComplete from './auto-complete'

export default {
  install (Vue) {
    Vue.component('AutoComplete', AutoComplete)
  }
}
